import Banner from "./views/BannerHome";
import HomePageNumber from "./views/HomePageNumber";
import HomeBring from "./views/HomeBring";
import HomePackage from "./views/HomePackage";
import HomeTeamOfExperts from "./views/HomeTeamOfExperts";
import HomeNew from "./views/HomeNew";
import CustomersPartners from "./views/CustomersPartners";
import Advise from "./views/Advise";
import CusPart from "./views/CuPart";
import Prize from "../Introduction/Prize";
import HomeGigital from "./views/HomeDigital";

export default function Homepage() {
  return (
    <div>
      <Banner />
      <HomeBring />
      <HomeGigital />
      <HomePackage />
      {/* <HomeTeamOfExperts /> */}
      {/* <CustomersPartners /> */}
      <CusPart />
      <HomePageNumber />
      <Prize />
      <HomeNew />
      <Advise />
    </div>
  );
}
